module.exports = __webpack_public_path__ + "img/welcome.cb3db480.svg";